import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  AttributeDefinition,
  FormTypes,
  VoltageClass,
} from '../../../models/section-definition.model';
import { FormTypeLabelMap } from '../../../enums/enum-mappings';

@Component({
  selector: 'lib-data-model-customization-attribute',
  templateUrl: './data-model-customization-attribute.component.html',
  styleUrls: ['./data-model-customization-attribute.component.scss'],
  standalone: false,
})
export class DataModelCustomizationAttributeComponent implements OnInit {
  @Input() attribute!: AttributeDefinition;
  @Input() showVoltageClass: boolean = true;
  @Output() editClicked = new EventEmitter<number>();
  @Output() deleteClicked = new EventEmitter<number>();
  @Output() toggled = new EventEmitter<void>();
  fieldType: string = '';
  VoltageClass = VoltageClass;

  isVoltageExcluded(voltage: VoltageClass): boolean {
    const key = VoltageClass[voltage];
    return this.attribute.excludedVoltages?.some(v => (v as any) === key || Number(v) === voltage) ?? false;
  }

  onEditClicked(id: number){
    this.editClicked.emit(id);
  }

  onDeleteClicked(id: number){
    this.deleteClicked.emit(id);
  }

  ngOnInit() : void {
    this.fieldType = FormTypeLabelMap[this.attribute.fieldType!];
  }

  onToggle(){
    this.toggled.emit();
  }
}
